export default __webpack_public_path__ + "static/meshery-contrib-stats-cbcb67d680a68263297f3e347787c4dc.webp";